import {
  UPDATE_FIELD,
  SET_CONFIG,
  RESET_CONFIG,
  RESET_FILES,
  UPDATE_FILE,
  UPDATE_OVERLAYIMAGE,
  UPDATE_ATTRIBUTE,
  UPDATE_GREENSCREENBACK,
  UPDATE_GAME

} from './types';
const initialState = {
  active: false,
  // Print settings
  printable: false,
  maxPrint: 3,
  // App customization
  cover: "",
  theme: "DARK",
  photoRatio: 1,
  // Share settings
  SMS:false,
  appId: "",
  appSecret: "",
  facebookToken: "",
  pageId: "",
  templateId: "",
  
  setting: "1",
  overlayImages: [],
  greenScreenBackgrounds: []
  , files: {}
  , game: false
  , winners: []
  , eventId: ""
};
function configReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_FIELD: {
      return Object.assign({}, state, {
        config: {
          ...state.config,
          ...action.payload
        }
      });
    }
    case UPDATE_FILE: {
      return Object.assign({}, state, {
        files: {
          ...state.files,
          ...action.payload
        }
      });
    }
    case SET_CONFIG: {
      const newConfig = action.payload;
      console.log("newConfig", newConfig.config)
      // booleans are received as strings so they need to be converted
      return Object.assign({}, state, action.payload.config);
    }
    case RESET_CONFIG: {
      console.log("RESET_CONFIG", action.payload)
      return Object.assign({}, initialState, action.payload);
    }
    case RESET_FILES: {
      const newState = Object.assign({}, state, {
        files: initialState.files
      });
      return newState;
    }
    case UPDATE_OVERLAYIMAGE: {
      return Object.assign({}, state, {
        overlayImages:
          [
            ...action.payload
          ]

      });
    }
    case UPDATE_GREENSCREENBACK: {
      return Object.assign({}, state, {
        greenScreenBackgrounds:
          [
            ...action.payload
          ]

      });
    }
    case UPDATE_ATTRIBUTE: {
      return Object.assign({}, state, action.payload);
    }
    case UPDATE_GAME: {
      return Object.assign({}, state, {
        game: action.payload.active, winners: action.payload.winners
      });
    }
    default:
      return state;
  }

}
export default configReducer;